import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Skeleton } from '@usepepper/sprout-kit-ui';
import { View } from 'react-native';

const SKELETON_FIELD_COUNT = 5;
const SKELETON_LABEL_HEIGHT = 16;
const SKELETON_LABEL_WIDTH = 100;
const SKELETON_INPUT_HEIGHT = 40;

export const EditAccountFormSkeleton: React.FC = () => {
  const [styles] = useStyles();

  return (
    <View style={styles.form}>
      {Array.from({ length: SKELETON_FIELD_COUNT }).map((_, index) => (
        <View key={index} style={styles.inputGroup}>
          <Skeleton
            height={SKELETON_LABEL_HEIGHT}
            variant="text"
            width={SKELETON_LABEL_WIDTH}
          />
          <Skeleton
            height={SKELETON_INPUT_HEIGHT}
            variant="rect"
            width="100%"
          />
        </View>
      ))}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  form: {
    gap: theme.sk.spacing.spaceMedium,
  },
  inputGroup: {
    gap: theme.sk.spacing.spaceXsmall,
  },
}));
